import { YhBox } from "@/components/YhBox";
import { StatementDataTable } from "./StatementDataTable";
import { StatementSearchBox } from "./StatementSearchBox";


export const StatementDataBox = () => {

    return (
        <>
            <StatementSearchBox />
            <YhBox>
                <StatementDataTable />
            </YhBox>
        </>
    )
}
